export default __webpack_public_path__ + "static/media/imgUploadIcon.7b57c9f5.svg";